import React from 'react';

const colors = {
  text: '#fff',
  dot: '#0343fb',
};

const KlickLogo = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 638.15 316.79"
      {...props}
    >
      <polygon
        style={{ fill: colors.text }}
        points="80 152.24 145.75 79.41 82.44 79.41 50.08 117.75 50.08 0 0 0 0 242.11 50.08 242.11 50.08 190.1 93.82 242.11 158.01 242.11 80 152.24"
      />
      <rect
        style={{ fill: colors.text }}
        x="170.35"
        width="50.09"
        height="242.11"
      />
      <rect
        style={{ fill: colors.text }}
        x="245.14"
        y="79.4"
        width="50.09"
        height="162.71"
      />
      <ellipse
        style={{ fill: colors.dot }}
        cx="270.19"
        cy="291.75"
        rx="25.05"
        ry="25.03"
      />
      <path
        style={{ fill: colors.text }}
        d="M455.8,242.11V193.18H403.64c-22,0-33.49-15.16-33.49-32.9s12.57-32,33.49-32H455.8V79.4H403.48c-50.7,0-83.82,35.43-83.82,80.89,0,49.28,38.18,81.82,83.82,81.82Z"
      />
      <path
        style={{ fill: colors.text }}
        d="M560.14,152.24,625.89,79.4h-63.3l-32.36,38.35V0H480.14V242.11h50.09v-52l43.73,52h64.19Z"
      />
      <path
        style={{ fill: colors.text }}
        d="M367.6,272h7.86v39.21H367.6v-16.1H352.23v16.1h-7.85V272h7.85v16.22H367.6Z"
      />
      <path
        style={{ fill: colors.text }}
        d="M429,278.89H409.36v9.21h18.13v6.67H409.36v9.49H429v6.95H401.5V272H429Z"
      />
      <path
        style={{ fill: colors.text }}
        d="M481,311.21l-2.54-7.29H461.39l-2.6,7.29h-8.42L465.18,272h9.49l14.8,39.21Zm-17.35-13.78H476.2l-6.28-17.86Z"
      />
      <path
        style={{ fill: colors.text }}
        d="M519.93,304.26h18.13v6.95h-26V272h7.86Z"
      />
      <path
        style={{ fill: colors.text }}
        d="M583.94,272v6.89H572.47v32.32h-7.85V278.89H553.15V272Z"
      />
      <path
        style={{ fill: colors.text }}
        d="M630.16,272H638v39.21h-7.85v-16.1H614.79v16.1h-7.86V272h7.86v16.22h15.37Z"
      />
    </svg>
  );
};

export default KlickLogo;
